import React, {useEffect, useState} from 'react';
import { Box, Typography } from '@mui/material';
import { getCreateQuickSightEmbedUrl } from '../../../api/quickSight';
import useActiveSite from '../../../hooks/useActiveSite';

const SCDashboardAnalytics = () => {
  const [report, setReport] = useState('');
  const activeSite = useActiveSite();

  const getQuickSightEmbedUrl = async (activeSite) => {
    const getCreateQuickSightEmbedUrlResponse = await getCreateQuickSightEmbedUrl('sd-analytics', activeSite.id);
    const getCreateQuickSightEmbedUrlResponseData = await getCreateQuickSightEmbedUrlResponse.json();

    if (getCreateQuickSightEmbedUrlResponse.ok) {
      setReport(getCreateQuickSightEmbedUrlResponseData.data);
    }
  };

  useEffect(() => {
    getQuickSightEmbedUrl(activeSite);
  }, [activeSite]);

  return (
    <>
      <Box mb={2}>
        <Typography variant="h6" color="textSecondary">
          Advanced Analytics
        </Typography>
      </Box>

      <iframe src={report} style={{ border: 'none', width: '100%', height: '80vh' }} title="Analytics" />
    </>
  );
};

export default SCDashboardAnalytics;
